import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerlogged';
import Componentes from '../../../components/user/solicitacao/listar/componentes';


function CompSolScreen () {
    return (
        <Fragment>
            <Head titulo="Componentes na Solicitação | Departamento de TI" />
            <Header />
            <Componentes />
            <Footer />
        </Fragment>
    );
}

export default CompSolScreen;